import { default as setCookie } from "@pb/utils/common/setCookie";
import { jsonToBase64 } from "@pb/utils/url/urlEncoding";
import constants from '../../constants';
const setCustomCookie = (bpid) => {
    if (bpid) {
        const encodedValue = jsonToBase64({
            bpid,
        });
        // calculating expiration around 3 months into future in hours
        const timeToExpirationInHours = 24 * 90;
        setCookie(constants.COOKIE_NAME, `##${encodedValue}##`, timeToExpirationInHours);
    }
};
export default setCustomCookie;
//# sourceMappingURL=setCustomCookie.js.map